import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const sendMailToSupplier = createApi(`SendMailToSupplierSlice`, "POST");

const SendMailToSupplierSlice = createSlice({
  name: 'SendMailToSupplierSlice',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendMailToSupplier.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendMailToSupplier.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(sendMailToSupplier.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default SendMailToSupplierSlice.reducer;
